var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import classnames from 'classnames';
import styles from './Grid.module.scss';
var getColumnClasses = function (breakpoints, offset) {
    if (offset === void 0) { offset = false; }
    var breakpointKeys = Object.keys(breakpoints);
    var classesForBreakpoints = breakpointKeys.reduce(function (classes, breakpoint, index) {
        var previousBreakpointValue = index > 0 ? breakpoints[breakpointKeys[index - 1]] : 0;
        if (breakpoints[breakpoint] &&
            breakpoints[breakpoint] > 0 &&
            previousBreakpointValue !== breakpoints[breakpoint]) {
            var classToAdd = "col-".concat(breakpoint).concat(offset ? '-offset' : '', "-").concat(breakpoints[breakpoint], "of12");
            return classes.concat(styles[classToAdd]);
        }
        return classes;
    }, []);
    var defaultReturnValue = offset ? [] : [styles['col-xs-12of12']];
    return classesForBreakpoints.length ? classesForBreakpoints : defaultReturnValue;
};
var getOffsetClasses = function (breakpoints) { return getColumnClasses(breakpoints, true); };
var ItemComponent = function (_a, ref) {
    var customClass = _a.className, component = _a.component, xs = _a.xs, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl, xxl = _a.xxl, xsOffset = _a.xsOffset, smOffset = _a.smOffset, mdOffset = _a.mdOffset, lgOffset = _a.lgOffset, xlOffset = _a.xlOffset, xxlOffset = _a.xxlOffset, rest = __rest(_a, ["className", "component", "xs", "sm", "md", "lg", "xl", "xxl", "xsOffset", "smOffset", "mdOffset", "lgOffset", "xlOffset", "xxlOffset"]);
    var Component = component || 'div';
    var classes = React.useMemo(function () { return getColumnClasses({ xs: xs, sm: sm, md: md, lg: lg, xl: xl, xxl: xxl }); }, [xs, sm, md, lg, xl, xxl]);
    var offsetClasses = React.useMemo(function () {
        return getOffsetClasses({
            xs: xsOffset,
            sm: smOffset,
            md: mdOffset,
            lg: lgOffset,
            xl: xlOffset,
            xxl: xxlOffset,
        });
    }, [xsOffset, smOffset, mdOffset, lgOffset, xlOffset, xxlOffset]);
    var className = classnames(classes, offsetClasses, customClass);
    return React.createElement(Component, __assign({ className: className, ref: ref }, rest));
};
/**
 * @tdr
 */
export var Item = React.memo(forwardRef(ItemComponent));
//# sourceMappingURL=Item.js.map